import React from 'react'

import clsx from 'clsx'

import classes from './TabsRoot.module.scss'

/** @type {import("./types").default} */
const TabsRoot = ({ children, value, className, ...rest }) => {
  return (
    <nav role="tablist" className={clsx('TabsRoot', classes.root, className)} {...rest}>
      <div className={classes.list}>
        {React.Children.toArray(children).map((child, index) => {
          const hasIndicator = value === child.props.value
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div className={classes.itemWrapper} key={`list-item-${index}`}>
              <span className={classes.item} data-testid="item">
                {child}
              </span>
              {hasIndicator && <span className={classes.indicator} />}
            </div>
          )
        })}
      </div>
    </nav>
  )
}

export default TabsRoot
